import { client } from 'api';
import * as types from '../../mutationTypes';

export default {
    async getAllAppliedUpdates({ commit }) {
        const response = await client.getAllAppliedUpdates();
        commit(types.BULK_ADD_APPLIED_UPDATES, response.data);
    },

    async getAllComplispaceUpdates({ commit }) {
        const response = await client.getAllComplispaceUpdates();
        commit(types.BULK_ADD_COMPLISPACE_PUBLISHED, response.data);
    }
};



// WEBPACK FOOTER //
// ./src/store/modules/published/actions.js